import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyD5e3NYdRv1f2ZPdBGfkb_LNiQ9Cxy1t8E",
  authDomain: "harshhasthkala-b6993.firebaseapp.com",
  projectId: "harshhasthkala-b6993",
  storageBucket: "harshhasthkala-b6993.firebasestorage.app",
  messagingSenderId: "230537659233",
  appId: "1:230537659233:web:82690d6da8cc50d8507b20",
  measurementId: "G-ZN2HQJKGF2"
};

let app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize services
const auth = getAuth(app);
const realtimeDb = getDatabase(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

export { app, auth, realtimeDb, firestore, storage };